import { render, staticRenderFns } from "./CheckinStatusCard.vue?vue&type=template&id=52b87598&"
import script from "./CheckinStatusCard.vue?vue&type=script&lang=js&"
export * from "./CheckinStatusCard.vue?vue&type=script&lang=js&"
import style0 from "./CheckinStatusCard.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports